import { InquiryStage, InquiryStageDefinition } from 'types/inquiries';

/**
 * This is a list of all inquiry stages. For our purposes, we consider "Search"
 * to be a special frontend-only "stage".
 */
export const ALL_INQUIRY_STAGES: InquiryStageDefinition[] = [
  { slug: 'accepted', name: 'Accepted', hasTab: true },
  { slug: 'made-1st-call', name: 'Made 1st Call', hasTab: true },
  { slug: 'viewings-scheduled', name: 'Viewings Scheduled', hasTab: true },
  { slug: 'offer-sent', name: 'Offer Sent', hasTab: true },
  { slug: 'offer-accepted', name: 'Offer Accepted', hasTab: true },
  { slug: 'for-collection', name: 'Collections', hasTab: true },

  { slug: 'search', name: 'Search', hasTab: false }
];

/** The inquiry stages used in Kumita 2. */
export const INQUIRY_PAGE_STAGES = ALL_INQUIRY_STAGES.filter(stage => stage.hasTab);

export const OFFER_SENT_STATUSES = [
  'Offer sent',
  'Client declined counter offer'
];

export enum InquiryDocumentType {
  OFFER = 'OFFER',
  CONTRACT = 'CONTRACT'
};

/**
 * Lead sources. Copied from Kumita 1.
 */
export const LEAD_SOURCES = [
  // Needs to be arranged alphabetically
  // { name: 'Website - Property', value: 1 },
  // { name: 'Website - FTF', value: 2 },
  { value: 18, name: 'Blog'},
  { value: 30, name: 'Carousell'},
  { value: 33, name: 'Contacted BC'},
  { value: 10, name: 'Dot-Property'},
  { value: 3, name: 'Email'},
  { value: 37, name: 'Events'},
  { value: 27, name: 'FB Chat'},
  { value: 28, name: 'FB Lead Form'},
  { value: 29, name: 'FB Marketplace'},
  { value: 21, name: 'FBP'},
  { value: 40, name: 'Instagram'},
  { value: 8, name: 'Lamudi'},
  { value: 46, name: 'Lazudi'},
  { value: 25, name: 'Mitula'},
  { value: 20, name: 'Mobile-App'},
  { value: 16, name: 'MyProperty'},
  { value: 41, name: 'Newsletter'},
  { value: 38, name: 'Offline Initiatives'},
  { value: 31, name: 'OLX'},
  { value: 7, name: 'Persquare'},
  { value: 47, name: 'Petal-Organic'},
  { value: 5, name: 'Phone'},

  // IT-230 requires these two added
  { value: 43, name: 'Phone - Website'},
  { value: 44, name: 'PLDT Global'},

  { value: 6, name: 'Property24'},
  { value: 39, name: 'Referral - Own'},
  { value: 34, name: 'Referral by Hoppler Partner Broker'},
  { value: 35, name: 'Referral by previous Hoppler client (tenant or buyer)'},
  { value: 36, name: 'Referral by Hoppler Personnel'},
  { value: 32, name: 'Rentpad'},
  { value: 9, name: 'SMS'},
  { value: 24, name: 'Trovit'},
  { value: 17, name: 'Viber'},
  { value: 19, name: 'Walk-In'},
  { value: 42, name: 'What’s App'},
  { value: 15, name: 'ZipMatch'},
  
  // IT-1750 -- ZipMatch Post Listing Inquiry
  { value: 45, name: 'ZipMatch Post Inquiry'},

  // IT-880 requires these sources be removed
  // { value: 26, name: 'Chat'},
  // { value: 11, name: 'Facebook'},
  // { value: 12, name: 'Others'},
  // { value: 4, name: 'Referral'},

  // IT-266 requires these sources be removed
  // { value: 22, name: 'GAD'},
  // { value: 23, name: 'Google'},
];
